import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Card, Form, Row, Col, Image, Spinner } from 'react-bootstrap'
import { handleInputChangeTarjetaCredito, submitProcesarPago } from 'src/reducer/action/pago';
import { withMask } from 'use-mask-input';
import Cards from 'react-credit-cards';
import valid from "card-validator";

// img
import Icofont from 'react-icofont';
import credito from 'src/assets/tcredito.webp'
import cvv from 'src/assets/cvv.webp'
// common
import { AlertCommon } from 'src/common/AlertCommon';
// import { getTotalPagar } from 'src/helpers/pagoFedpa';
import 'react-credit-cards/es/styles-compiled.css';
import { getTotalPagar } from 'src/helpers/pagoFedpa';
import { useMediaQuery } from 'react-responsive';
import InfoIcon from 'src/assets/components/InfoIcon';

export const TarjetaDeCredito = ({
    step,
    stepForward
}) => {

    const dispatch = useDispatch();
    const { polizas: polizasPagar } = useSelector(state => state.pago.pagar);
    const isMobile = useMediaQuery({ maxWidth: 768 });

    const [nameRequired, setNameRequired] = useState({
        estado: false,
        mensaje: null
    });


    const {
        loadingResponse,
        tarjetacredito: {
            name,
            focus,
            number,
            cvc,
            expiry
            // response,
            // checkingResponse
        },
        formaPago,
        email
    } = useSelector(state => state.pago);




    const [errors, setErrors] = useState({});

    const handleInputChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;

        console.log(name);


        // validacion de valor de tarjeta de acuerdo al algoritmo de luhn
        if (name === 'number') {


            const validation = valid.number(value);

            dispatch(handleInputChangeTarjetaCredito({ name, value }))

            setErrors({ ...errors, [name]: !validation.isValid })
        }
        else if (name === 'name') {

            const fullNameRegex =
                /^[A-Za-zÁÉÍÓÚáéíóúÑñ]+(?:\s+[A-Za-zÁÉÍÓÚáéíóúÑñ]+)+$/;

            dispatch(handleInputChangeTarjetaCredito({ name, value }))

            setErrors({ ...errors, [name]: !fullNameRegex.test(value) })
        } else if (name === 'expiry') {


            dispatch(handleInputChangeTarjetaCredito({ name, value }))

            setErrors({ ...errors, [name]: !valid.expirationDate(value).isValid })
        }else if (name === 'cvc') {

           const validation = valid.cvv(value);

           console.log("validation cvc", validation);

            dispatch(handleInputChangeTarjetaCredito({ name, value }))
            setErrors({ ...errors, [name]: !validation.isValid })
        }
        else {
            // set change en state
            dispatch(handleInputChangeTarjetaCredito({ name, value }))

            // set errors
            value?.length > 0
                ? setErrors({ ...errors, [name]: false })
                : setErrors({ ...errors, [name]: true })
        }


    }

    const handleInputFocus = (e) => {

        const { name } = e.target;
        dispatch(handleInputChangeTarjetaCredito({ name: 'focus', value: name }));
        // setpago({ ...pago, focus: e.target.name });
    }

    const setHandleErrors = (pay) => {
        const error = {};
        let countError = 0;

        for (const key in pay) {
            error[key] = !Boolean(pay[key]);
            if (!Boolean(pay[key])) countError += 1;
        }

        // validar el pay.name tenga nombre y apellido
        const partes = pay.name.trim().split(/\s+/);

        if (pay.name.length === 0) {
            error.name = true;
            countError += 1;
            setNameRequired({ estado: true, mensaje: 'El nombre y apellido son requeridos' });
        }
        else if (partes[1] === undefined || partes[1].length === 0) {
            error.name = true;
            countError += 1;
            setNameRequired({ estado: true, mensaje: 'El apellido es requerido' });
        } else if (number) {

        } else {
            setNameRequired({ estado: false, mensaje: null });
        }

        setErrors({ ...error });
        return countError;
    }


    const convertirFechaDDMM = (fecha) => {
        // Elimina la barra para obtener "DDMM"
        return fecha.replace("/", "");
    }

    const handleSubmitForm = (e) => {

        e.preventDefault();

        const countError = setHandleErrors({ name, number, cvc, expiry });

        console.log("countError", countError);

        if (countError === 0) {
            const dividoName = name.split(' ');
            const creditCard = {
                firstName: dividoName[0] || '',
                lastName: dividoName[1] || '',
                description: 'Pago de poliza',
                amount: getTotalPagar(polizasPagar) || 0,
                safeIdentifier: number || 0,
                validThru: convertirFechaDDMM(expiry) || '',
                cvv: cvc || ''
            };


            dispatch(submitProcesarPago({
                idorigen: formaPago,
                email: email,
                pagos: polizasPagar,
                tarjetaCredito: creditCard
            }, { step, stepForward }));

        } else {
            console.log(countError)
        }
    }

    return (
        <div>
            <br />
            <Row className='justify-content-center'>
                <Col md={4}>
                    <Cards
                        cvc={cvc}
                        expiry={`${expiry.split('/')[0] || 0}/${expiry.split('/')[1] || 0}`}
                        focused={focus}
                        name={name}
                        number={number}
                        placeholders={{
                            name: 'Nombre de la tarjeta'
                        }}
                    />
                    &nbsp;
                </Col>
                <Col md={5}>
                    <Card className='shadow border-0 card-tarjeta-responsive'>
                        {/* {JSON.stringify(response)} */}
                        <Card.Body>
                            <AlertCommon />
                            <Form onSubmit={handleSubmitForm} className='mx-1'>
                                <div className='text-center'>
                                    <Image
                                        src={credito}
                                        alt='tarjeta de credito'
                                        width={180}
                                        fluid
                                    />
                                </div>
                                <br />
                                <Form.Group>
                                    <p className='text-left h6 font-weight-bold'>Numero de tarjeta</p>
                                    <Form.Control
                                        type="text"
                                        name="number"
                                        value={number}
                                        // placeholder="__ ___ ___ __"
                                        onChange={handleInputChange}
                                        onFocus={handleInputFocus}
                                        maxLength={19}
                                        ref={withMask('9999 9999 9999 9999')}
                                        className={`border border-2 ${errors?.number ? 'border-bottom-danger input-error' : ''}`}
                                    // required
                                    />
                                    {errors?.number && <span style={{ color: "#DA4957",fontSize: '13px'}}>Favor ingrese un número de tarjeta válido<br /></span>}
                                </Form.Group>
                                <br />
                                <Form.Group>
                                    <Form.Label className='text-center h6 font-weight-bold'>Titular de la tarjeta</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        placeholder=""
                                        value={name}
                                        onChange={handleInputChange}
                                        onFocus={handleInputFocus}
                                        pattern="[A-Za-z\s]+"
                                        className={`border border-2 ${errors?.name ? 'border-bottom-danger input-error' : ' '}`}
                                    // required
                                    // ref={withMask('a-z')}
                                    />

                                    {/* {nameRequired.estado && <p className='text-danger'>{nameRequired.mensaje}</p>} */}
                                    {errors?.name && <span style={{ color: "#DA4957", fontSize: '13px' }}>Favor ingrese un nombre y apellido válidos<br /></span>}
                                    <span className='form-text pb-0 mb-0' style={{ fontSize: '13px' }}>
                                        <InfoIcon height={13} width={13} style={{ paddingBottom: '5px' }} />
                                        Nombre y apellido del titular de la tarjeta
                                    </span>
                                </Form.Group>
                                <br />
                                <Row>
                                    <Col sm={8}>
                                        <Form.Label
                                            className='text-center h6 font-weight-bold'>
                                            Fecha de expiracion
                                        </Form.Label>
                                        <Row>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    name='expiry'
                                                    placeholder='MM/YY'
                                                    value={expiry}
                                                    onChange={handleInputChange}
                                                    onFocus={handleInputFocus}
                                                    minLength={5}
                                                    maxLength={5}
                                                    ref={withMask('99/99', { placeholder: 'MM/YY' })}
                                                    className={`border border-2 ${errors?.expiry ? 'border-bottom-danger input-error' : ' '}`}
                                                />
                                                {errors?.expiry && <span style={{ color: "#DA4957" , fontSize: '13px'}}>Favor ingrese una fecha de expiración válida <br /></span>}
                                                <span className='form-text pb-0 mb-0' style={{ fontSize: '12px' }}>
                                                    <InfoIcon height={13} width={13} style={{ paddingBottom: '5px' }} />
                                                    {/* El formato de fecha es MM/AA, donde AA es el año que va en dos dígitos*/}
                                                    El formato de fecha MM/AA
                                                </span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col sm={4}>
                                        <Form.Group>
                                            <p className='mt-1 d-inline-block h6 font-weigth-bold'>cvc</p>
                                            &nbsp;
                                            <div className="help-tip">
                                                <p className='text-center'
                                                    style={{
                                                        width: isMobile ? '120px' : '300px'
                                                    }}
                                                >
                                                    Código de Seguridad de la Tarjeta
                                                    <img
                                                        src={cvv}
                                                        width={130}
                                                        height={80}
                                                        alt='ok'
                                                    />
                                                </p>
                                            </div>
                                            <Form.Control
                                                type="text"
                                                name="cvc"
                                                placeholder="cvc"
                                                maxLength={4}
                                                value={cvc}
                                                onChange={handleInputChange}
                                                onFocus={handleInputFocus}
                                                ref={withMask('999')}
                                                className={`border border-2 ${errors?.cvc ? 'border-bottom-danger' : ''}`}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <br />
                                <div className='text-center'>
                                    <button
                                        type='submit'
                                        variant='primary'
                                        className='btn-pay'
                                        disabled={loadingResponse || errors?.number || errors?.name || errors?.cvc || errors?.expiry}
                                    >
                                        {
                                            loadingResponse
                                                ?
                                                (
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />

                                                )
                                                : (
                                                    <React.Fragment>
                                                        &nbsp;
                                                        Pagar
                                                        &nbsp;
                                                        <Icofont icon='credit-card' />
                                                    </React.Fragment>
                                                )
                                        }
                                    </button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <div style={{ paddingBottom: isMobile ? '100px' : '0' }} />
        </div>
    )
}
